import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7117 3.14087C5.68751 3.14087 1.5 6.8896 1.5 11.6474C1.5 13.8364 2.39499 15.8236 3.84822 17.3213C4.18023 17.6651 4.26071 17.9636 4.21153 18.1561C4.08118 18.6639 3.83722 19.1358 3.49815 19.5357C3.32469 19.7402 3.27368 20.0219 3.36437 20.2743C3.45505 20.5267 3.67363 20.7115 3.93762 20.7589C4.31152 20.826 4.69178 20.8596 5.07166 20.8591C6.30976 20.8589 7.46721 20.506 8.447 19.8952C9.17299 20.0649 9.93213 20.1539 10.7117 20.1539C10.8305 20.1539 10.9488 20.1518 11.0667 20.1477C9.51573 18.9268 8.50928 17.1021 8.50928 15.0047C8.50928 11.1778 11.8596 8.25891 15.7546 8.25891C17.1324 8.25891 18.442 8.62412 19.5593 9.26554C18.4378 5.69645 14.8599 3.14087 10.7117 3.14087Z"
        fill={colorValue}
      />
      <path
        d="M15.7546 20.5004C12.4439 20.5004 9.75928 18.0396 9.75928 15.0047C9.75928 11.9697 12.4439 9.50891 15.7546 9.50891C19.0654 9.50891 21.75 11.9697 21.75 15.0047C21.75 16.4062 21.1778 17.6846 20.2358 18.6552C19.9481 18.9529 19.7429 19.348 19.8455 19.7483C19.9578 20.1861 20.168 20.5927 20.4603 20.9374C20.2264 20.9794 19.9892 21.0004 19.7515 21C18.8975 21 18.1062 20.7322 17.4567 20.2759C16.9171 20.4225 16.3455 20.5004 15.7546 20.5004Z"
        fill={colorValue}
      />
    </svg>
  );
};
